// TODO revisit where and how this is stored - JT-121065
export const CUSTOMER_SERVICE_NUMBER = '1 (877) 377-8276';

// Android app Play Store link
export const ANDROID_APP_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.varomoney.bank';
// iOS app App Store link
export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/id1517676784';
